import WellBeingPartnerModal from './WellBeingPartnerModal'

export default WellBeingPartnerModal
